import { forwardRef } from "react";
import classes from "./Textarea.module.scss";
import { clsx } from "clsx";
import { TextareaProps } from "./TextareaProps";
import { useFormControl } from "@/hooks/useFormControl";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea(props, ref) {
    const { className, id, hasError, ...htmlProps } = props;

    const formControl = useFormControl();
    const textareaId = id ?? formControl?.id;
    const textareaHasError = hasError ?? formControl?.hasError ?? false;

    return (
      <textarea
        ref={ref}
        id={textareaId}
        className={clsx(
          classes.textarea,
          { [classes.valid]: !textareaHasError && formControl?.isValid },
          className,
        )}
        {...(textareaHasError && { "aria-invalid": true })}
        {...htmlProps}
      />
    );
  },
);
